// The AIChatPanel component passes this storage key to a ChatCompose component, which will
// use it to persist the state of the chat conversation in local storage.
export const AI_PROMPT_STORAGE_KEY = "ai_prompt";
